import React from 'react';
import clsx from 'clsx';
import { StepIconProps } from '@material-ui/core/StepIcon';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

export const StepIcon =
  (step: number, onStepClick: (step: number, completed: boolean) => void) => (props: StepIconProps) => {
    const classes = useStyles();
    const { active, completed } = props;

    const handleStepClick = () => {
      onStepClick(step + 1, !!completed);
    };

    return (
      <div
        onClick={handleStepClick}
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.active]: completed,
        })}
      >
        <Typography variant="h6">{`0${step + 1}`}</Typography>
      </div>
    );
  };
